import "./index.scss";
import {
  FeaturedNews,
  HomeCampaigns,
  HomeEducationCards,
  MainSearch
} from "components/UI/organisms";
import { HomePromotions } from "components/templates";

export const Home = () => {
  return (
    <div className="home">
      <MainSearch />
      <HomePromotions />
      <HomeCampaigns />
      <HomeEducationCards />
      <FeaturedNews />
    </div>
  );
};
